export interface ArtikelQuery {
  itemAttributes?: number[];
  query?: string;
  itemSort?: string,
  itemFilterExtendedArray?: any,
  itemFilterArray?: any
}
